export const MESSAGE_AVATAR_OFFSET_PX = 48;
export const MESSAGE_MIN_WIDTH_PX = 284;
// SpacingWrapper padding
export const MESSAGE_SPACING_VERTICAL_PX = 4;
export const MESSAGE_SPACING_HORIZONTAL_PX = 10;
export const SPOTLIGHT_SPACING_PADDING_PX = 8;
export const SPOTLIGHT_WRAPPER_PADDING_PX = 8;
export const SPOTLIGHT_STANDALONE_PADDING_PX = SPOTLIGHT_SPACING_PADDING_PX + SPOTLIGHT_WRAPPER_PADDING_PX;
// Spotlight VISITOR bubble's own inner content padding (buildSpotlightMessageHistoryTheme's contentPadding)
export const SPOTLIGHT_VISITOR_CONTENT_PADDING_VERTICAL_PX = 6;
export const SPOTLIGHT_VISITOR_CONTENT_PADDING_HORIZONTAL_PX = 12;